export const GET_LOGIN_USER = 'GET_LOGIN_USER';

export const IS_EXP_VALID = 'IS_EXP_VALID';

export const SET_DISPLAY_PAGE = 'SET_DISPLAY_PAGE'